import { createContext } from 'react';

import { InternalCategoricalBarChartConfig } from '../types/categorical-bar-chart.js';
import { defaultConfig } from '../types/defaults.js';

export type CategoricalBarChartBaseConfigContextValue = Pick<
  InternalCategoricalBarChartConfig,
  | 'colorPalette'
  | 'valueRepresentation'
  | 'groupMode'
  | 'layout'
  | 'colorPaletteMode'
  | 'toolbar'
  | 'intents'
>;

export const CategoricalBarChartBaseConfigContext =
  createContext<CategoricalBarChartBaseConfigContextValue>(defaultConfig);
